import { render, staticRenderFns } from "./OrgaoShow.vue?vue&type=template&id=4ce20b15&scoped=true&"
import script from "./OrgaoShow.vue?vue&type=script&lang=js&"
export * from "./OrgaoShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce20b15",
  null
  
)

export default component.exports